define('src/plugins/underscore.extension',[
    'underscore', 'utils',
], function(_, U) {

    _.mixin({
        /**
         * If the callback is a string, retrieve it first, then call it with
         * the rest of the arguments.
         * @param  {Object} context
         * @param  {Function|String} callback
         * @param  {Array} args - to pass to the callback.
         * @return {Mixed} return value of the callback or undefined.
         */
        callback: function(context, callback, args) {
            if (context && _.isString(callback)) callback = context[callback];
            if (_.isFunction(callback)) return callback.apply(context, args);
        },

        /**
         * Round a number to a specific number of decimal places: 1.005 → 1.01
         * Based on sindresorhus round-to node module:
         * https://github.com/sindresorhus/round-to
         * @param  {Number} value to round to.
         * @param  {Number} precision of decimal places (integer).
         * @param  {Function} fn key to a Math function.
         * @return {Number} value rounded to precision.
         */
        roundTo: function(value, precision, fn) {
            fn = fn || 'round';
            var exponent = precision > 0 ? 'e' : 'e-';
            var exponentNeg = precision > 0 ? 'e-' : 'e';
            precision = Math.abs(precision);
            return Number(Math[fn](value + exponent + precision) + exponentNeg + precision);
        },

    });

    return _;
});

